import React from "react";
import Box from "@mui/material/Box";

export default function AgentRolePill({ role }) {
  const isAdmin = (role || "").toLowerCase().includes("admin");

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px: 1.25,
        py: 0.25,
        borderRadius: "20px",
        fontFamily: "Inter",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: "18px",
        color:  "#405261",
        background: isAdmin ? "#F3FBFF;" : "#F9FAFA",
        border: `1px solid ${isAdmin ? "#148DFD" : "#C5CED6"}`,
        whiteSpace: "nowrap",
      }}
    >
      {role || "—"}
    </Box>
  );
}
